// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/prescribe/modules/prescribe-view/prescribe-view.less
// module id = 3833
// module chunks = 0